var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassdoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#2AB304"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4053_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8584 39.4293H15.5731C15.5731 41.9533 17.6171 44 20.1411 44H33.8558C36.3798 44 38.4264 41.9533 38.4264 39.4293V20.656C38.4264 20.5627 38.3544 20.4893 38.2611 20.4893H34.0211C33.9318 20.4893 33.8571 20.564 33.8571 20.6573V39.4307L33.8584 39.4293ZM33.8584 12C36.3811 12 38.4278 14.0467 38.4278 16.5733H20.1438V35.344C20.1438 35.4347 20.0691 35.5107 19.9771 35.5107H15.7384C15.6451 35.5107 15.5718 35.4347 15.5718 35.344V16.5707C15.5731 14.048 17.6171 12 20.1411 12H33.8584Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4053_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassdoor);
export default __webpack_public_path__ + "static/media/glassdoor.7d306a01b901121d7ad33ad9390441e7.svg";
export { ForwardRef as ReactComponent };